<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <div class="filters">
                    <label for="city-search">Filtro:</label>
                    <v-select id="city-search" :options="cities" v-model="citySelected">
                        <template #no-options="{ }">
                        Nenhum filtro encontrado.
                        </template>
                    </v-select>
                </div>

                <b-table striped hover sticky-header head-variant="dark" :items="items" :fields="fields">
                    <template v-slot:cell(action)="data">
                        <b-button v-show="!!data.item.check === true" variant="danger" @click="delItem(data)">Remover</b-button>
                        <b-button v-show="!!data.item.check === false" variant="primary" @click="addItem(data)">Adicionar</b-button>
                    </template>
                </b-table>

                <div class="total-count">
                    Total: <b>{{totalChecked}}</b> contato<span v-show="totalChecked > 1">s</span> adicionado<span v-show="totalChecked > 1">s</span>.
                </div>

                <div class="add-or-remove-all">
                    <b-button variant="primary" @click="addAll()">Adicionar todos</b-button>
                    <b-button variant="danger" @click="delAll()">Remover todos</b-button>
                </div>

            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    props: {
        wallets: {
            type: Array,
            default: []
        },
        cities: {
            type: Array,
            default: []
        }
    },
    data(){
        return {
            at_wallets: this.wallets,
            citySelected: null,
            elementos: 1,
            items: [],
            fields: [
                {
                    key: 'action',
                    label: 'Ação'
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'phone',
                    label: 'Telefone',
                    sortable: true
                },
                {
                    key: 'city',
                    label: 'Cidade',
                    sortable: true
                },
            ],
        }
    },
    methods:{
        addItem (data) {
            data.item.check = true
            const { name, phone } = data.item
            this.$emit('addClient', { name, phone });

        },
        delItem (data) {
            data.item.check = false
            const { name, phone } = data.item
            this.$emit('removeClient', { name, phone });
            
        },
        addAll () {
            this.items.forEach(item => {
                item.check = true
                const { name, phone } = item
                this.$emit('addClient', { name, phone });
            })
        },
        delAll () {
            this.items.forEach(item => {
                item.check = false
            });
            this.$emit('removeAllClients');
        },
    },
    computed: {

        totalChecked () {
            let total = 0
            this.wallets.forEach(el => {
                if(!!el.check) total++
            });
            return total
        }

    },
    watch:{
        citySelected (value) {
            if(!!value) {
                let newItems = []
                this.at_wallets.forEach(item => {
                    if(item.city === value) {
                        newItems.push(item)
                    }
                })
                this.items = newItems
            } else {
                this.items = this.at_wallets
            }
        }
    },
    mounted () {
        this.items = this.at_wallets
    }

}
</script>

<style>

</style>